import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeDLServiceService {
  constructor(public http: HttpClient) {}

  //#region Home Dashboard
  getHomeDashboard(): Observable<any> {
    return this.http.get<any>(`Home/GetHomeDashboard`);
  }
  getPatientDistributionChart(): Observable<any> {
    return this.http.get<any>(`Home/PatientDistributionChart`);
  }
  getVisitDistributionChart(): Observable<any> {
    return this.http.get<any>(`Home/VisitDistributionChart`);
  }
  getMedicalStatisticsChart(): Observable<any> {
    return this.http.get<any>(`Home/MedicalStatisticsChart`);
  }
  getPatientFlowStatus(): Observable<any> {
    return this.http.get<any>(`Home/PatientFlowStatus`);
  }
  //#endregion

}
